export { DetailsLink } from './DetailsLink';
